import { Button } from "../../../components/forms";
import { GoPlus } from "react-icons/go";
import { ListPicker } from "../../../components/generic/ListPicker";
import { usePickerhook } from "../../../hooks/usePickerhook";
import { SearchBar } from "../../../components/generic/SearchBar";
import { useState } from "react";
import { UserItem } from "../../../components/users/UserItem";
import AdduserModal from "../../../components/users/AddUsers";
import { NoDepartment } from "../../../components/users/NoDepartment";
import AddDepartment from "../../../components/users/AddDepartment";
import { useDeptHook } from "../../../hooks/useDeptHook";
import { DepartmentItem } from "../../../components/users/DepartmentIem";
import { NoEmployee } from "../../../components/users/NoEmployee";
import AddEmployee from "../../../components/Modules/Employees/AddEmployee";
import EmployeeItem from "./EmployeeItem";
import useDepartmentHook from "../../../hooks/useDepartmentHook";
import useEmployeeHook from "../../../hooks/useEmployeeHook";
import usePositionHook from "../../../hooks/usePositionHook";
import PersonalInfo from "./PersonalInfo";
import Workinformation from "./Workinformation";
import AddContract from "../../../components/Modules/Employees/AddContract";
import useContractHook from "../../../hooks/useContractHook";
import ContractItem from "./ContractItem";
import { onGetContractsById } from "../../../services/contract";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";
export default () => {
  const departmentPicked = usePickerhook();
  const positionPicked = usePickerhook();
  const rolepicked = usePickerhook();
  const { AllOrgDepts } = useDeptHook();
const {selectedEmployee}=useStateGetter()
  const { Contracts, refresh } = useContractHook();

  const [showadddept, setshowadddept] = useState(false);
  const { selectedOrgDepts } = useDepartmentHook();
  const { allorgPositions } = usePositionHook();
  const [entered, setentered] = useState("");
  const tabs = ["All", "Running", "Completed", "Terminated"];
  const tabViews = [<>All</>, <>Running</>, <>Complteted</>];

  const [selectedTab, setselectedTab] = useState(tabs[0]);
  const [selectedTabview, setselectedTabview] = useState(tabViews[0]);
  const [contratdetails, setcontratdetails] = useState({});
  const ActionItem2 = ({ title }: any) => (
    <div
      onClick={() => {
        setselectedTabview(tabViews[tabs.indexOf(title)]);
        setselectedTab(title);
      }}
      className={` m-2 rounded-[8px]    p-2  font-semibold ${
        selectedTab == title
          ? "bg-textbg text-white"
          : " bg-faintBlue text-blueGray "
      }`}
    >
      <p className="  cursor-pointer text-xs">{title}</p>
    </div>
  );

  const onChange = (e: string) => {
    setentered(e);
  };

  return (
    <div className="w-full   flex  ">
      {showadddept && <AddContract refresh={refresh} show={setshowadddept} />}
      <div className={` p-6 bg-white  w-full  rounded-[20px]`}>
        <div className="  w-full  flex justify-between items-center  ">
          <p className="text-textbg font-medium text-sm mb-2 text-[16px] bg-white">
            Contracts({Contracts .filter((l)=>l.employeeID==selectedEmployee.id).length})
          </p>   <Button
            width={200}
            disabled={false}
            text={
              <>
                 <GoPlus size={15} className=" mx-1 inline" /> Add Contract
              </>
            }
            onBtnClick={() => {
              setshowadddept(true);
            }}
          />
        </div>
        <div className="w-full flex justify-between items-center">
          <div className="flex  gap-2">
            <ListPicker
              hook={departmentPicked}
              notitle
              title="Department"
              list={
                selectedOrgDepts
                  ? selectedOrgDepts?.map((i) => {
                      return { name: i.deptName, code: i.id };
                    })
                  : []
              }
            />
            <ListPicker
              hook={positionPicked}
              notitle
              title="Position"
              list={
                allorgPositions
                  ? allorgPositions?.map((i: any) => {
                      return { name: i.positionTitle, code: i.id };
                    })
                  : []
              }
            />
          </div>
          <SearchBar
            placeholder="Search User"
            onchange={onChange}
            value={entered}
          />
        </div>
        <hr />
        <div className="flex mb-4 ">
          {tabs.map((i) => (
            <ActionItem2 title={i} />
          ))}
        </div>
        {Contracts .filter((l)=>l.employeeID==selectedEmployee.id).length > 0 ? (
          <div className="grid grid-cols-2 gap-4">
            {" "}
            {Contracts .filter((l)=>l.employeeID==selectedEmployee.id).map((i: any) => (
              <ContractItem item={i} />
            ))}
          </div>
        ) : (
          <div className="flex justify-center items-center bg-white rounded-[10px] p-6 ">
            <p className=" font-light text-primary text-lg">No Contracts </p>
          </div>
        )}
      </div>
    </div>
  );
};
